import React from "react";
import { cn } from "@heroui/react";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import { ArrowRight } from "lucide-react";

const PAGE_CONTENT_CLASS =
  "h-[calc(100dvh-288px)] min-h-0 overflow-y-auto px-1";
const MODAL_CONTENT_CLASS =
  "flex-1 min-h-0 overflow-y-auto px-1";

const AddCampaignLayout = ({
  cancelButtonText = "Back",
  saveButtonText = "Save and Next",
  onCancel,
  onSaveAndNext,
  title,
  description,
  children,
  saveButtonIcon = true,
  isSaving = false,
  variant = "page",
  contentClassName,
}) => {
  return (
    <div className={cn("w-full flex flex-col gap-4", variant === "modal" && "flex-1 min-h-0")}>
      <div className={cn("w-full flex flex-col gap-6", variant === "modal" && "flex-1 min-h-0")}>
        <div className="flex flex-col gap-1 py-2.5 border-b border-gray-200 dark:border-gray-800">
          <h3 className="font-bold text-[1.4rem] font-inter text-gray-800 dark:text-gray-100">
            {title}
          </h3>
          <p className="text-[0.894rem] text-gray-500 dark:text-gray-400 font-inter">
            {description}
          </p>
        </div>

        <div
          className={cn(
            variant === "modal" ? MODAL_CONTENT_CLASS : PAGE_CONTENT_CLASS,
            contentClassName,
          )}
        >
          {children}
        </div>
      </div>
      {/* footer action button */}
      <div className="flex gap-2 justify-between">
        <SecondaryButton
          title={cancelButtonText}
          onClick={() => {
            onCancel();
          }}
          className="shadow-none border-none"
        />
        <PrimaryButton
          onClick={() => {
            onSaveAndNext();
          }}
          startContent={false}
          endContent={
            saveButtonIcon ? <ArrowRight size={16} color="#fff" /> : null
          }
          disabled={isSaving}
          isLoading={isSaving}
        >
          {saveButtonText}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default AddCampaignLayout;
